import { render, staticRenderFns } from "./AgendaBlockItem.vue?vue&type=template&id=f1487560&scoped=true"
import script from "./AgendaBlockItem.vue?vue&type=script&lang=js"
export * from "./AgendaBlockItem.vue?vue&type=script&lang=js"
import style0 from "./AgendaBlockItem.vue?vue&type=style&index=0&id=f1487560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1487560",
  null
  
)

export default component.exports